<div class="d-flex flex-row justify-content-between">
  <div ngbDropdown #BW="ngbDropdown">
    <button type="button" class="btn d-flex align-items-center" id="bw" ngbDropdownAnchor (focus)="BW.open()">
      <img src="assets/icons/probesFamilies/black&White.png">
      <p>{{ selectedBWV() }}</p>
    </button>
    <div ngbDropdownMenu aria-labelledby="bw">
      <button ngbDropdownItem value="None" (click)="resetFormBWV()">
        {{ 'none' | translate }}
      </button>
      <div class="d-flex flex-column">
        @for (bwv of chunkArr(); track bwv) {
          <mat-checkbox class="text-capitalize d-flex align-self-center"
            [(ngModel)]="formBW.value[bwv]">
            <p type="button" placement="right" ngbTooltip="{{ bwv }}">{{ bwv }}</p>
          </mat-checkbox>
        }
      </div>
    </div>
  </div>

  @if (clientsList().length > 0) {
    <div *kaHasRoles="['bo-dip-wl-admin']; checkRealm: true" ngbDropdown #Clients="ngbDropdown">
      <button type="button" class="btn d-flex align-items-center" id="clients" ngbDropdownAnchor (focus)="Clients.open()">
        <p>{{ 'setting-nav-clients' | translate }}</p>
      </button>
      <div ngbDropdownMenu aria-labelledby="clients">
        <button ngbDropdownItem value="None" (click)="resetFormClient()">
          {{ 'none' | translate }}
        </button>
        <div class="d-flex flex-column">
          @for (client of clientsList(); track client) {
            <mat-checkbox class="text-capitalize d-flex align-self-center"
              [(ngModel)]="formClient.value[client.name]">
              <p type="button" placement="right">{{ client.name }}</p>
            </mat-checkbox>
          }
        </div>
      </div>
    </div>
  }
  <button type="button" (click)="applyFilters()"
    class="search btn btn-outline-success d-flex justify-self-center">
    <mat-icon>search</mat-icon>
  </button>
</div>